module.exports = __webpack_public_path__ + "DINNextLTPro-BlackItalic.eot?7c818fb6585c1e0ae4437137e2e3e181";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BlackItalic.eot
// module id = 325
// module chunks = 0